export default __webpack_public_path__ + "d7df9dd6ee14946cb4686ee961fc5733.svg";